import { CommonModule } from '@angular/common';
import {
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
  signal,
} from '@angular/core';
import { ToastData } from './toast.types';

@Component({
  selector: 'lepi-toast',
  standalone: true,
  templateUrl: './toast.html',
  styleUrls: ['./toast.css'],
  imports: [CommonModule],
})
export class Toast implements OnInit, OnDestroy {
  @Input() toastData!: ToastData;
  @Output() removed = new EventEmitter<string>();

  width = signal(100);
  duplicatesCount = 0;

  private intervalId?: ReturnType<typeof setInterval>;
  private timeoutId?: ReturnType<typeof setTimeout>;
  destroy = signal(false);

  get title() {
    return this.toastData?.title;
  }

  get message() {
    return this.toastData?.message;
  }

  get options() {
    return {
      closeButton: this.toastData?.closeButton ?? true,
      progressBar: this.toastData?.progressBar ?? true,
      enableHtml: this.toastData?.enableHtml ?? false,
      titleClass: this.toastData?.titleClass ?? 'toast-title',
      messageClass: this.toastData?.messageClass ?? 'toast-message',
    };
  }

  ngOnInit() {
    const timeOut = Number(this.toastData?.timeOut ?? 0);
    if (timeOut > 0) {
      this.startProgressBar();
      this.timeoutId = setTimeout(() => {
        this.remove();
      }, timeOut);
    }
  }

  ngOnDestroy() {
    if (this.intervalId) {
      clearInterval(this.intervalId);
    }
    if (this.timeoutId) {
      clearTimeout(this.timeoutId);
    }
  }

  private startProgressBar() {
    if (!this.options.progressBar) return;

    const step = 100 / (this.toastData.timeOut / 10);
    this.intervalId = setInterval(() => {
      const newWidth = this.width() - step;
      if (newWidth <= 0) {
        this.width.set(0);
        if (this.intervalId) {
          clearInterval(this.intervalId);
        }
      } else {
        this.width.set(newWidth);
      }
    }, 10);
  }

  remove() {
    this.destroy.set(true);

    // stop timers before emitting
    if (this.intervalId) {
      clearInterval(this.intervalId);
      this.intervalId = undefined;
    }
    if (this.timeoutId) {
      clearTimeout(this.timeoutId);
      this.timeoutId = undefined;
    }

    // ensure id exists before emitting
    if (this.toastData?.id) {
      this.removed.emit(this.toastData.id);
    }
  }
}
